import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import TodoList from '../views/TodoList.vue';
import TaxClearedList from '../views/TaxClearedList.vue';
import PublicityList from '../views/PublicityList.vue';
import PendingSubmitList from '../views/PendingSubmitList.vue';
import ReviewList from '../views/ReviewList.vue';
import RejectResubmitList from '../views/RejectResubmitList.vue';
import FieldWorkList from '../views/FieldWorkList.vue';
import DifficultList from '../views/DifficultList.vue';
import ArchivedOrderList from '../views/ArchivedOrderList.vue';
import OrderCreate from '../views/OrderCreate.vue';
import OrderDetail from '../views/OrderDetail.vue';
import OrderReceiptEdit from '../views/OrderReceiptEdit.vue';
import FinancialList from '../views/FinancialList.vue';
import CustomerData from '../views/CustomerData.vue';
import ChannelCenterPage from '../views/ChannelCenterPage.vue';
import FieldPartnersPage from '../views/FieldPartnersPage.vue';
import SettingsAccessCenter from '../views/SettingsAccessCenter.vue';
import DispatchManagePage from '../views/DispatchManagePage.vue';
import Login from '../views/Login.vue';
import MainLayout from '../views/layouts/MainLayout.vue';
import store from '../store';
import { FIELD_PARTNERS_MODULE_TITLE } from '../constants/nav-labels';

Vue.use(Router);

function getDispatchReceiverMenuFromStore(store) {
    var user = store.getters.currentUser;
    var m = user && user.dispatch_receiver_menu;
    if (!m || typeof m.tax_stages !== 'boolean' || typeof m.biz_stages !== 'boolean') {
        return null;
    }
    return m;
}

function dispatchReceiverWorkbenchRedirect(menu) {
    if (menu.tax_stages) {
        return '/todos';
    }
    if (menu.biz_stages) {
        return '/tax-cleared';
    }
    return '/dispatch/manage';
}

var router = new Router({
    mode: 'hash',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                guestOnly: true
            }
        },
        {
            path: '/',
            component: MainLayout,
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: '',
                    name: 'home',
                    component: Home
                },
                {
                    path: 'todos',
                    name: 'todos',
                    component: TodoList
                },
                {
                    path: 'tax-cleared',
                    name: 'tax-cleared',
                    component: TaxClearedList
                },
                {
                    path: 'publicity',
                    name: 'publicity',
                    component: PublicityList
                },
                {
                    path: 'pending-submit',
                    name: 'pending-submit-list',
                    component: PendingSubmitList
                },
                {
                    path: 'review',
                    name: 'review-list',
                    component: ReviewList
                },
                {
                    path: 'reject-resubmit',
                    name: 'reject-resubmit-list',
                    component: RejectResubmitList
                },
                {
                    path: 'field-work',
                    name: 'field-work',
                    component: FieldWorkList
                },
                {
                    path: 'difficult',
                    name: 'difficult',
                    component: DifficultList
                },
                {
                    path: 'complete',
                    name: 'complete',
                    component: ArchivedOrderList
                },
                {
                    path: 'leads',
                    name: 'leads',
                    component: CustomerData
                },
                {
                    path: 'customer-data',
                    redirect: { name: 'leads' }
                },
                {
                    path: 'orders/create',
                    name: 'order-create',
                    component: OrderCreate
                },
                {
                    path: 'orders/completed',
                    redirect: { name: 'complete' }
                },
                {
                    path: 'orders/:id/receipt/edit',
                    name: 'order-receipt-edit',
                    component: OrderReceiptEdit
                },
                {
                    path: 'orders/:id',
                    name: 'order-detail',
                    component: OrderDetail
                },
                {
                    path: 'orders',
                    redirect: { name: 'todos' }
                },
                {
                    path: 'settings/basic-info',
                    redirect: { name: 'settings-access', query: { section: 'basic' } }
                },
                {
                    path: 'settings/quick-links',
                    redirect: { name: 'settings-access', query: { section: 'quick' } }
                },
                {
                    path: 'settings/access',
                    name: 'settings-access',
                    component: SettingsAccessCenter
                },
                {
                    path: 'settings/permissions',
                    redirect: { name: 'settings-access', query: { tab: 'roles' } }
                },
                {
                    path: 'settings/users',
                    redirect: { name: 'settings-access', query: { tab: 'users' } }
                },
                {
                    path: 'settings/field-partners',
                    redirect: { name: 'field-partners' }
                },
                {
                    path: 'field-partners',
                    name: 'field-partners',
                    meta: {
                        pageTitle: FIELD_PARTNERS_MODULE_TITLE
                    },
                    component: FieldPartnersPage
                },
                {
                    path: 'config',
                    redirect: { name: 'settings-access', query: { section: 'quick' } }
                },
                {
                    path: 'quick-links',
                    redirect: { name: 'settings-access', query: { section: 'quick' } }
                },
                {
                    path: 'dispatched-orders',
                    name: 'dispatched-orders',
                    redirect: { name: 'dispatch-manage' }
                },
                {
                    path: 'dispatch',
                    redirect: { name: 'dispatch-manage' }
                },
                {
                    path: 'dispatch/orders',
                    name: 'dispatch-orders',
                    redirect: { name: 'dispatch-manage' }
                },
                {
                    path: 'dispatch/manage',
                    name: 'dispatch-manage',
                    component: DispatchManagePage
                },
                {
                    path: 'financials',
                    name: 'financials',
                    component: FinancialList
                },
                {
                    path: 'channels',
                    name: 'channels',
                    component: ChannelCenterPage
                },
                {
                    path: 'channels/overview',
                    redirect: { name: 'channels', query: { tab: 'orders' } }
                },
                {
                    path: 'channels/create',
                    redirect: { name: 'channels', query: { tab: 'create' } }
                },
                {
                    path: 'channels/orders',
                    redirect: { name: 'channels', query: { tab: 'orders' } }
                },
                {
                    path: 'channels/settings',
                    redirect: { name: 'channels', query: { tab: 'orders' } }
                },
                {
                    path: 'channels/permissions',
                    redirect: { name: 'channels', query: { tab: 'orders' } }
                },
                {
                    path: 'channels/revenue',
                    redirect: { name: 'channels', query: { tab: 'orders' } }
                }
            ]
        }
    ]
});

router.beforeEach(function (to, from, next) {
    var isAuthenticated = store.getters.isAuthenticated;

    if (to.matched.some(function (record) { return record.meta.requiresAuth; }) && !isAuthenticated) {
        next('/login');
        return;
    }

    if (to.matched.some(function (record) { return record.meta.guestOnly; }) && isAuthenticated) {
        next('/');
        return;
    }

    if (isAuthenticated && store.getters.currentUser) {
        var roles = store.getters.currentUser.roles || [];
        if (roles.indexOf('cancellation-specialist') >= 0) {
            var p = to.path || '';
            if (p.indexOf('/settings') === 0 || p.indexOf('/dispatch') === 0 || p.indexOf('/field-partners') === 0) {
                next('/todos');
                return;
            }
        }
        if (roles.indexOf('field-specialist') >= 0) {
            var fp = to.path || '';
            if (fp === '/' || fp === '') {
                next('/field-partners');
                return;
            }
            if (fp.indexOf('/field-partners') !== 0) {
                next('/field-partners');
                return;
            }
        }
        if (roles.indexOf('channel-specialist') >= 0) {
            var cp = to.path || '';
            if (cp === '/' || cp === '') {
                next('/channels');
                return;
            }
            var channelBlocked = [
                '/todos',
                '/tax-cleared',
                '/publicity',
                '/pending-submit',
                '/review',
                '/reject-resubmit',
                '/complete',
                '/field-work',
                '/difficult',
                '/orders/create',
                '/financials',
                '/dispatch',
                '/dispatch/orders',
                '/dispatch/manage',
                '/dispatched-orders',
                '/settings',
                '/field-partners'
            ];
            for (var ci = 0; ci < channelBlocked.length; ci++) {
                var bp = channelBlocked[ci];
                if (cp === bp || cp.indexOf(bp + '/') === 0) {
                    next('/channels');
                    return;
                }
            }
            if (cp.indexOf('/orders/') === 0) {
                next('/channels');
                return;
            }
        }

        var dMenu = getDispatchReceiverMenuFromStore(store);
        if (dMenu) {
            var dp = to.path || '';
            var dRedirect = dispatchReceiverWorkbenchRedirect(dMenu);
            if (dp === '/' || dp === '') {
                next(dRedirect);
                return;
            }
            var dispatchBlockedPrefixes = [
                '/settings',
                '/leads',
                '/customer-data',
                '/channels',
                '/field-partners',
                '/financials',
                '/orders/create',
                '/field-work',
                '/difficult'
            ];
            for (var dxi = 0; dxi < dispatchBlockedPrefixes.length; dxi++) {
                var dbp = dispatchBlockedPrefixes[dxi];
                if (dp === dbp || dp.indexOf(dbp + '/') === 0) {
                    next(dRedirect);
                    return;
                }
            }
            if (!dMenu.tax_stages && (dp === '/todos' || dp.indexOf('/todos/') === 0)) {
                next(dRedirect);
                return;
            }
            if (!dMenu.biz_stages) {
                var dBizPaths = ['/tax-cleared', '/publicity', '/pending-submit', '/review', '/reject-resubmit', '/complete'];
                for (var dbi = 0; dbi < dBizPaths.length; dbi++) {
                    var dbz = dBizPaths[dbi];
                    if (dp === dbz || dp.indexOf(dbz + '/') === 0) {
                        next(dRedirect);
                        return;
                    }
                }
            }
        }
    }

    next();
});

router.afterEach(function (to) {
    var appName = store.getters.appName || '今兔执照注销管理系统';
    var matched = to.matched.filter(function (r) {
        return r.meta && r.meta.pageTitle;
    });
    if (!matched.length) {
        document.title = appName;
        return;
    }
    var pageTitle = matched[matched.length - 1].meta.pageTitle;
    document.title = pageTitle + ' — ' + appName;
});

export default router;



// WEBPACK FOOTER //
// ./resources/assets/js/router/index.js